"use strict";

import angular from "angular";
/**
 * @component nuNandaButton
 * O <nu-nanda-button> è um componente que é usado para mostrar o botão da Nanda
 */

import template from "./nanda-button.component.html";
import "./themes/nanda-button.component.scss";

const name = "nuNandaButton";
const factory = [
    function () {
        return {
            restrict: "E",
            template,
            scope: {
                loading: "=",
                noBorder: "="
            }
        };
    }
];
angular.module("nucont.shared").directive(name, factory);
export default { name, factory };
